import { getRailsClient } from "../client";
import { Assessment, Question, UserStatistics } from "./types/quizTypes";

interface QuizResponse {
  assessment: Assessment;
  userStatistics: UserStatistics;
  question: Question;
  nextLesson: any;
  noMoreAttempts: boolean;
}

export const getAssessment = async (lessonId: number): Promise<QuizResponse> => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/levels/undefined/lessons/${lessonId}/assessments`;
    const { data } = await client.get(API);
    return data;
  } catch (error) {
    console.error("Error getting assessment:", error);
    throw error;
  }
};

export const submitQuizQuestion = async ({
  slug,
  questionId,
}: {
  slug: string;
  questionId: string;
}) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/assessment_questions/${questionId}`;
    const { data } = await client.put(API, {
      assessmentQuestion: {
        slug: slug,
      },
    });
    return data;
  } catch (error) {
    console.error("Error submitting quiz question:", error);
    throw error;
  }
};

export const retakeQuiz = async (lessonId: number) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/levels/undefined/lessons/${lessonId}/assessments`;
    const { data } = await client.post(API);
    return data;
  } catch (error) {
    console.error("Error restarting quiz:", error);
    throw error;
  }
};
